import { useEffect, useRef } from "react";
import Location from "./Location";
import gql from "graphql-tag";
import Settings from "./Settings";

const SEND_TELEMETRY = gql`
mutation sendTelemetry($longitude: Float, $latitude: Float, $time: DateTime) {
  sendTelemetry(telemetry: {longitude: $longitude, latitude: $latitude, time: $time})
}
`;

const CHECK_TELEMETRY_INTERVAL = 10000;
const SEND_TELEMETRY_INTERVAL = 30000;
const SEND_TELEMETRY_INTERVAL_NO_GPS = 5 * 60000;

export function sendTelemetryToServer(client, longitude, latitude, time, onComplete) {
  client.mutate({
    mutation: SEND_TELEMETRY,
    variables: { longitude, latitude, time },
    refetchQueries: ['TravelInformation']
  }).then(data => {
    if (!data.data.sendTelemetry) {
      console.log('Telemetry not accepted');
    } else {
      console.log('Telemetry accepted')
    }
    onComplete?.()
  }).catch(err => {
    onComplete?.(err)
  });
}

const SendTelemetry = props => {
  const intervalId = useRef(null)
  const lastTelemetrySentTime = useRef(null)

  const onTelemetryComplete = (error) => {
    if (error) {
      console.error("Error during telemetry check:", error);
    } else {
      console.log("Telemetry check complete")
      lastTelemetrySentTime.current = new Date().getTime()
    }
  };

  const sendTelemetry = () => {
    const now = new Date().getTime()

    if (!props.account) {
      console.log("Don't send telemetry, not logged in")
      onTelemetryComplete()
      return
    }

    const interval = Settings.isGpsEnabled() ? SEND_TELEMETRY_INTERVAL : SEND_TELEMETRY_INTERVAL_NO_GPS
    const nextTelemetryTime = lastTelemetrySentTime.current ? lastTelemetrySentTime.current + interval : new Date().getTime()

    if (lastTelemetrySentTime.current !== null) {
      if (nextTelemetryTime > now) {
        console.log(`Too soon to send telemetry, send in ${((nextTelemetryTime - now)/1000).toFixed(0)} seconds`)
        return
      }
    }

    console.log("Time to send telemetry")

    if (!Settings.isTelemetryEnabled()) {
      console.log("Auto-telemetry disabled")
      onTelemetryComplete()
    } else {
      //Get coordinates to send telemetry
      if (Settings.isGpsEnabled()) {
        Location.getGPSLocation(
          position => {
            const time = position.timestamp ? new Date(position.timestamp).toISOString() : null
            const longitude = position.coords.longitude
            const latitude = position.coords.latitude
            sendTelemetryToServer(props.client, longitude, latitude, time, onTelemetryComplete)
          },
          error => {
            //Do not call onError, this can be sent later
            console.log(`Geolocation failed, ${error}`)
            onTelemetryComplete(error)
          },
          { enableHighAccuracy: true }
        )
      } else {
        //Use ip location
        Location.getIpLocation(props.client, location => {
          const time = new Date().toISOString()
          const longitude = location.longitude
          const latitude = location.latitude
          sendTelemetryToServer(props.client, longitude, latitude, time, onTelemetryComplete)
        }, error => {
          onTelemetryComplete(error)
        })
      }
    }
  }

  useEffect(() => {
    intervalId.current = setInterval(sendTelemetry, CHECK_TELEMETRY_INTERVAL);
    sendTelemetry()

    // Cleanup function to clear the timeout when the component unmounts
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        intervalId.current = null;
      }
    };
  }, []); // Empty dependency array means this effect runs once on mount
}


export default SendTelemetry;